// extracted by mini-css-extract-plugin
export var acitonButtons = "_bv-0";
export var additionalIcon = "_bv-f";
export var block = "_bv-1";
export var blockContent = "_bv-7";
export var blockDescription = "_bv-8";
export var blockIcon = "_bv-9";
export var blockTitle = "_bv-6";
export var border = "_bv-a";
export var center = "_bv-l";
export var edge = "_bv-b";
export var edgeLabel = "_bv-c";
export var edgePath = "_bv-d";
export var error = "_bv-e";
export var flowchart = "_bv-g";
export var flowchartContent = "_bv-h";
export var highlighted = "_bv-3";
export var hover = "_bv-4";
export var icon = "_bv-i";
export var left = "_bv-m";
export var navButton = "_bv-j";
export var navButtons = "_bv-k";
export var right = "_bv-n";
export var selected = "_bv-2";
export var small = "_bv-5";